import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import Breadcrumbs from "../../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import BackBtn from "../../../../../components/Common/backBtn";
import InputRadioField from "../../../../../components/Common/inputRadioField";
import InputTextField from "../../../../../components/Common/inputTextField";
import SucessModal from "../../../../../components/Modal/SucessModal";

const PGDegreeForm = ({ edit = false, view = false }) => {
  const { id } = useParams();
  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}pg-degree/get/${id}`)
      .then((response) => {
        setValue("active", response.data.active);
        setValue("pg_degree", response.data.pg_degree);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    (view || edit) && getMenuData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit]);

  const onSubmit = (fields) => {
    if (edit) {
      axios
        .patch(`${process.env.REACT_APP_API_URL}pg-degree/update/${id}`, fields)
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    } else {
      axios
        .post(`${process.env.REACT_APP_API_URL}pg-degree/create`, fields)
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Masters", link: "/master-primary-specialisation" },
      { text: "PG Degree", link: "/master-pg-degree" },
      {
        text: edit
          ? "Edit PG Degree"
          : view
            ? "View PG Degree"
            : "Add New PG Degree",
        link: "",
      },
    ],
    [],
  );

  return (
    <>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      <BackBtn navigatePath="/master-pg-degree" />
      <div className="healtharticle mt-5">
        <div className="pt-3 ms-3">
          {/* <Breadcrumbs
                        breadcrumbText="Master"
                        breadcrumbLink=""
                        nestedText="PG Degree"
                        nestedLink=""
                        nestedText2={edit ? "Edit PG Degree" : "Add New PG Degree"}
                        nestedLink2=""
                    /> */}
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
          <div className="row car-dep-form">
            <div className="col-5">
              <InputTextField
                register={register}
                errors={errors}
                labelName="PG Degree"
                errorText="Please enter the PG Degree"
                name="pg_degree"
                placeholder="Type here..."
                disable={view}
              />
            </div>
            <div className="col-3">
              <InputRadioField
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                disabled={view}
              />
            </div>
          </div>

          {!view && (
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          )}
        </form>
      </div>
      {success && (
        <SucessModal
          page={"/master-pg-degree"}
          name="new PG Degree"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default PGDegreeForm;
